import React from 'react'
import { Popover, Tooltip } from '../../Elements'
import { Tag as BlueprintTag } from '@blueprintjs/core'
import { DocumentTagAdditionPopover } from './DocumentTagAdditionPopover'
import _ from 'lodash'

export const DocumentTags = ({ allTags, documentTags, documentId, addTag, removeTag }) => {
  const orderedTags = _.orderBy(documentTags, [(t) => t.name.toLowerCase()], ['asc'])
  const tagStyle = { margin: '0 .25em .5em .25em' }
  return <>
    {
      orderedTags.map(t => {
        return <Tooltip
          content={`This is no longer an active document tag. You cannot re-add this tag after it is removed.`}
          disabled={t.is_active}
        >
          <BlueprintTag
            style={tagStyle}
            minimal
            children={t.name}
            intent={t.is_active ? 'primary' : 'warning'}
            round
            onRemove={() => {
              removeTag(documentId, t.id)
            }}
          />
        </Tooltip>
      })
    }
    <Popover
      content={<DocumentTagAdditionPopover
        tagOnClick={(tagId) => addTag(documentId, tagId)}
        tags={allTags.filter(t => !documentTags?.some(dt => dt.id === t.id))}
      />}
      targetTagName='div'
      targetProps={{ style: { minHeight: '2em', minWidth: '2em', width: 'fit-content' } }}
      children={<BlueprintTag
        style={tagStyle}
        minimal
        children='Add Tag +'
      />
      }
    />
  </>
}